import React, { useEffect, useState } from "react";
import { API_BASE } from "../../../admin/utils/api";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import "./admission_faq.css";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";

// Function to clean all inline styles from HTML
const cleanHTML = (html) => {
  if (!html) return "";
  let cleaned = html;
  cleaned = cleaned.replace(/<\/?span[^>]*>/gi, "");
  // Only remove inline styles from non-table elements
  cleaned = cleaned.replace(/<(?!t[dhr]|table|thead|tbody)(\w+)([^>]*) style="[^"]*"([^>]*)>/gi, '<$1$2$3>');
  return cleaned;
};


const AdmissionFAQ = () => {
  const [faqGroups, setFaqGroups] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [openGroupId, setOpenGroupId] = useState(null);
  const [openFaqId, setOpenFaqId] = useState(null);

  const fetchPublicFaqs = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE}/api/admin/faqs/public?t=${Date.now()}`, {
        method: 'GET',
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });
      const data = await res.json();
      if (!res.ok) throw new Error("Failed to load FAQs");
      setFaqGroups(data || {});
    } catch (err) {
      setError(err.message || "Error loading FAQs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPublicFaqs();
  }, []);

  const groupOrder = Object.keys(faqGroups);

  const renderAnswerHtml = (html) => (
    <span dangerouslySetInnerHTML={{ __html: cleanHTML(html) }} />
  );

  return (
    <div>
      <h1 className="title">FAQ&apos;s</h1>
      <hr />

      {loading && <p className="faq-loading">Loading FAQs...</p>}
      {error && <p className="faq-error">{error}</p>}
      {!loading && !error && groupOrder.length === 0 && (
        <p className="faq-empty">No FAQs are available right now.</p>
      )}

      {!loading && !error && groupOrder.length > 0 && (
        <div className="faq-groups">
          {groupOrder.map((key, index) => {
            const group = faqGroups[key];

            return (
              <section key={key} className="faq-group">
                <Accordion
                  key={index}
                  title={group.typeName}
                  isActive={openGroupId === index}
                  onClick={() =>
                    setOpenGroupId(openGroupId === index ? null : index)
                  }
                >
                  <ul className="faq-items" >
                    {group.faqs.map((faq) => {
                      const isOpen = openFaqId === faq.id;

                      return (
                        <li key={faq.id} className="page-content-lists" id="faq-item" >
                          <button
                            type="button"
                            className={`faq-question-btn ${isOpen ? "active" : ""}`}
                            onClick={() => setOpenFaqId(isOpen ? null : faq.id)}
                          >
                            <h4 className="faq-question">{faq.question}</h4>
                            <span className="faq-toggle">
                              {isOpen ? (
                                <IoMdArrowDropup size={22} />
                              ) : (
                                <IoMdArrowDropdown size={22} />
                              )}
                            </span>
                          </button>

                          {isOpen && (
                            <div className="faq-answer">
                              <p className="faq-text">{renderAnswerHtml(faq.answer)}</p>
                            </div>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </Accordion>
              </section>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AdmissionFAQ;
